module.exports = __webpack_public_path__ + "static/img/vn.c0129c1f.svg";